import axios from "axios";

// When the user logs in, they must enter their username to check if an
// account exists.
function UsernameForm(props) {
    // Validate submitted username
    const handleSubmit = async (e) => {
        // Prevent default form submit behavior (page reload, etc.)
        e.preventDefault();

        // Ensure username exists before sending request to backend
        let username = document.getElementById("email-input").value;
        if (username === undefined || username === "") {
            props.setError({ "error": true, "error-msg": "Please provide a username and try again." })
            return;
        }

        // Check that user record exists
        await axios.post('/api/validate-user',
            { "username": username },
            { withCredentials: true, crossDomain: true }
        ).then((response) => {
            // Clear errors
            props.setError({ "error": false, "error-msg": "" });

            let isStudent = response.data.is_student;
            if (isStudent) {
                // Valid student accounts are logged in with just a username
                props.redirectToExplore();
            } else {
                props.setValidatedUsername(username);
            }
        }).catch((error) => {
            props.setError({ "error": true, "error-msg": error.response.data.message });
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label className="label" for="email-input">Username</label>
                <input type="text" id="email-input" className="login-credentials" name="email-input"></input>
            </div>
            <input type="submit" value="Submit" id="login-button" />
        </form>
    )
}

export default UsernameForm;